"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthModalManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var forgot_password_modal_1 = require("./forgot-password-modal");
var login_modal_1 = require("./login-modal");
var otp_verification_modal_1 = require("./otp-verification-modal");
var signup_modal_1 = require("./signup-modal");
var AuthModalManager = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, branding = _a.branding, siteName = _a.siteName, authentication = _a.authentication, _b = _a.initialModal, initialModal = _b === void 0 ? "login" : _b, onAuthSuccess = _a.onAuthSuccess, siteConfig = _a.siteConfig;
    var _c = (0, react_1.useState)(isOpen ? initialModal : null), activeModal = _c[0], setActiveModal = _c[1];
    var _d = (0, react_1.useState)(null), otpData = _d[0], setOtpData = _d[1];
    // Update active modal when isOpen changes
    react_1.default.useEffect(function () {
        if (isOpen && !activeModal) {
            setActiveModal(initialModal);
        }
        else if (!isOpen) {
            setActiveModal(null);
            setOtpData(null);
        }
    }, [isOpen, initialModal, activeModal]);
    var handleClose = function () {
        setActiveModal(null);
        setOtpData(null);
        onClose();
    };
    var handleSwitchToSignup = function () {
        setActiveModal("signup");
    };
    var handleSwitchToLogin = function () {
        setActiveModal("login");
    };
    var handleSwitchToForgotPassword = function () {
        setActiveModal("forgot-password");
    };
    var handleSignupSuccess = function (data) {
        setOtpData({
            cellNumber: data.cellNumber,
            country: data.country,
            email: data.email,
            signupData: data.signupData,
            developmentOtp: data.developmentOtp,
            smsEventId: data.smsEventId,
        });
        setActiveModal("otp");
    };
    var handleBackToSignup = function () {
        setActiveModal("signup");
    };
    var handleOtpVerificationSuccess = function (userData) {
        if (onAuthSuccess) {
            onAuthSuccess(userData);
        }
        handleClose();
    };
    var handleLoginSuccess = function (userData) {
        if (onAuthSuccess) {
            onAuthSuccess(userData);
        }
        handleClose();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(login_modal_1.LoginModal, { isOpen: activeModal === "login", onClose: handleClose, branding: branding, siteName: siteName, authentication: authentication, onSwitchToSignup: handleSwitchToSignup, onSwitchToForgotPassword: handleSwitchToForgotPassword, onLoginSuccess: handleLoginSuccess }), (0, jsx_runtime_1.jsx)(signup_modal_1.SignupModal, { isOpen: activeModal === "signup", onClose: handleClose, branding: branding, siteName: siteName, onSignupSuccess: handleSignupSuccess, onSwitchToLogin: handleSwitchToLogin, siteConfig: siteConfig }), (0, jsx_runtime_1.jsx)(forgot_password_modal_1.ForgotPasswordModal, { isOpen: activeModal === "forgot-password", onClose: handleClose, branding: branding, siteName: siteName, onBackToLogin: handleSwitchToLogin }), otpData && ((0, jsx_runtime_1.jsx)(otp_verification_modal_1.OtpVerificationModal, { isOpen: activeModal === "otp", onClose: handleClose, branding: branding, siteName: siteName, cellNumber: otpData.cellNumber, country: otpData.country, email: otpData.email, onVerificationSuccess: handleOtpVerificationSuccess, onBackToSignup: handleBackToSignup, developmentOtp: otpData.developmentOtp, signupData: otpData.signupData }))] }));
};
exports.AuthModalManager = AuthModalManager;
